import React from 'react';
import ACHIcon from './ACHIcon';
import AttorneyIcon from './AttorneyIcon';
import BalanceREFIIcon from './BalanceREFIIcon';
import CashDepositIcon from './CashDepositIcon';
import DirectElectronicDepositIcon from './DirectElectronicDepositIcon';
import InHouseLegalIcon from './InHouseLegalIcon';
import ManualIcon from './ManualIcon';
import SyndicationIcon from './SyndicationIcon';
import WireIcon from './WireIcon';
import { TransactionType } from '../../graphql/types';

const sizeMapping: { [key: string]: number } = {
  xxs: 20,
  xs: 25,
  sm: 40,
  md: 50,
  lg: 75,
  xl: 100
};

export const supportedPaymentMethodIdsforIcons = [
  'ACH',
  'ATTORNEY',
  'BALANCE_REFI',
  'CASH_DEPOSIT',
  'DIRECT_ELECTRONIC_DEPOSIT',
  'IN_HOUSE_LEGAL',
  'MANUAL',
  'SYNDICATION',
  'WIRE'
];

const paymentMethodIdToIcon: { [key: string]: React.FC<any> } = {
  ACH: ACHIcon,
  ATTORNEY: AttorneyIcon,
  BALANCE_REFI: BalanceREFIIcon,
  CASH_DEPOSIT: CashDepositIcon,
  DIRECT_ELECTRONIC_DEPOSIT: DirectElectronicDepositIcon,
  IN_HOUSE_LEGAL: InHouseLegalIcon,
  MANUAL: ManualIcon,
  SYNDICATION: SyndicationIcon,
  WIRE: WireIcon
};

export const supportedTransactionTypesforIcons = [TransactionType.Syndication, TransactionType.AchProgramFee];

const transactionTypeToIcon: { [key in TransactionType]?: React.FC<any> } = {
  [TransactionType.Syndication]: SyndicationIcon,
  [TransactionType.AchProgramFee]: ACHIcon
};

interface IconProps {
  id?: string;
  type?: TransactionType;
  color?: string;
  size?: 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}

export const Icon: React.FC<IconProps> = ({ id, type, color, size = 'md' }) => {
  if ((id && type) || (!id && !type)) return null;

  let SelectedIcon;
  if (id) SelectedIcon = paymentMethodIdToIcon[id];
  if (type) SelectedIcon = transactionTypeToIcon[type];

  const iconSize = sizeMapping[size];

  return SelectedIcon ? <SelectedIcon height={iconSize} width={iconSize} color={color} /> : <></>;
};
